import { render } from "./CommodityDialog.vue?vue&type=template&id=33502d37&scoped=true"
import script from "./CommodityDialog.vue?vue&type=script&lang=js"
export * from "./CommodityDialog.vue?vue&type=script&lang=js"

import "./CommodityDialog.vue?vue&type=style&index=0&id=33502d37&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33502d37"]])

export default __exports__